import { useState } from "react";
import { Badge } from "react-bootstrap";

import ContainerAnimation from "components/ContainerAnimation";
import { usePatientQuote } from "providers/Quote/PatientQuote";

import PatientQuoteReportList from "./PatientQuoteReportList";
import PatientQuoteReportSearch from "./PatientQuoteReportSearch";

const PatientQuoteReport = () => {
  const { patientConcludedQuotesTotal } = usePatientQuote();

  const [selectedNavTab, setSelectedNavTab] = useState("quote-data");

  const handleTabClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    setSelectedNavTab(e.currentTarget.id);
  };

  return (
    <ContainerAnimation className="content">
      {/* Título e Pesquisa */}
      <div className="bg-white">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-12 col-sm-auto">
              <h1>Relatório dos Orçamentos</h1>
            </div>
            <div className="col-12 col-sm-auto">
              <PatientQuoteReportSearch />
            </div>
            <div className="col-12">
              <ul className="nav nav-tabs">
                <li className="nav-item">
                  <span
                    id="quote-data"
                    className={`nav-link link-primary ${
                      selectedNavTab === "quote-data" && "active"
                    }`}
                    onClick={handleTabClick}
                  >
                    Orçamentos Concluídos
                    <Badge bg="primary ml-1 text-white">
                      {patientConcludedQuotesTotal}
                    </Badge>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="tab-content">
          {selectedNavTab === "quote-data" && <PatientQuoteReportList />}
        </div>
      </div>
    </ContainerAnimation>
  );
};

export default PatientQuoteReport;
